module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.customer.id) ? _c('div', [_c('breadcrumb', {
    attrs: {
      "crumbs": _vm.crumbs
    }
  }), _vm._v(" "), _c('flash-message'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12 ls-lg-margin-bottom-in-sm"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('router-link', {
    staticClass: "ls-btn ls-btn-primary ls-xs-margin-bottom ls-float-right ls-no-margin ls-xs-margin-right",
    attrs: {
      "to": {
        name: 'edit_customer',
        params: {
          id: _vm.customer.id
        }
      }
    },
    slot: "button"
  }, [_c('i', {
    staticClass: "fa fa-pencil-square-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('customers.main.edit')))])]), _vm._v(" "), _c('authorized-link', {
    attrs: {
      "tag": "destroy_customer"
    }
  }, [_c('a', {
    staticClass: "ls-btn ls-btn-danger ls-float-right ls-xs-margin-bottom ls-xs-margin-right ls-no-margin",
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        _vm.setInactiveData(_vm.customer, _vm.index)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('application.button.inactive')))])])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12 ls-no-padding ls-display-flex flex-wrap-wrap"
  }, [(_vm.customer) ? _c('div', {
    staticClass: "col-md-12 col-lg-7 col-xlg-6 ls-display-flex ls-md-margin-bottom"
  }, [_c('div', {
    staticClass: "ls-box ls-sm-space ls-display-flex flex-wrap-wrap"
  }, [_c('header', [_c('h3', {
    staticClass: "ls-title-3"
  }, [_vm._v(_vm._s(_vm.$t('customers.show.subscriber_data')))])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "ls-box-body row ls-display-flex flex-wrap-wrap"
  }, [_c('label', {
    staticClass: "ls-label col-lg-4 col-xlg-3 col-xs-6"
  }, [_c('b', {
    staticClass: "ls-label-text"
  }, [_vm._v(_vm._s(_vm.$t('customers.attributes.id')))]), _vm._v(" "), _c('p', {
    attrs: {
      "data-test": "customer.name"
    }
  }, [_vm._v(_vm._s(_vm.customer.id))])]), _vm._v(" "), _c('label', {
    staticClass: "ls-label col-lg-4 col-xlg-3 col-xs-6"
  }, [_c('b', {
    staticClass: "ls-label-text"
  }, [_vm._v(_vm._s(_vm.$t('customers.show.name')))]), _vm._v(" "), _c('p', {
    attrs: {
      "data-test": "customer.name"
    }
  }, [_vm._v(_vm._s(_vm.customer.name))])]), _vm._v(" "), _c('label', {
    staticClass: "ls-label col-xlg-3 col-lg-4 col-xs-6"
  }, [_c('b', {
    staticClass: "ls-label-text"
  }, [_vm._v(_vm._s(_vm.$t('customers.show.cpf')))]), _vm._v(" "), _c('p', {
    attrs: {
      "data-test": "customer.cpf"
    }
  }, [_vm._v(_vm._s(_vm.getCpf))])]), _vm._v(" "), (_vm.customer.kind === 'C') ? _c('label', {
    staticClass: "ls-label col-xlg-3 col-lg-4 col-xs-6"
  }, [_c('b', {
    staticClass: "ls-label-text"
  }, [_vm._v(_vm._s(_vm.$t('customers.show.cnpj')))]), _vm._v(" "), _c('p', {
    attrs: {
      "data-test": "customer.cnpj"
    }
  }, [_vm._v(_vm._s(_vm.getCnpj))])]) : _vm._e(), _vm._v(" "), _c('label', {
    staticClass: "ls-label col-xlg-3 col-lg-4 col-xs-6"
  }, [_c('b', {
    staticClass: "ls-label-text"
  }, [_vm._v(_vm._s(_vm.$t('customers.show.subscriber_type')))]), _vm._v(" "), (_vm.customer.kind === 'P') ? _c('p', {
    attrs: {
      "data-test": "customer.person_type"
    }
  }, [_vm._v(_vm._s(_vm.$t('customers.show.personal')))]) : _c('p', {
    attrs: {
      "data-test": "customer.person_type"
    }
  }, [_vm._v(_vm._s(_vm.$t('customers.show.customer_person')))])]), _vm._v(" "), (_vm.customer.contact) ? _c('label', {
    staticClass: "ls-label col-lg-4 col-xlg-3 col-xs-6"
  }, [_c('b', {
    staticClass: "ls-label-text"
  }, [_vm._v(_vm._s(_vm.$t('customers.show.since')))]), _vm._v(" "), _c('p', {
    attrs: {
      "data-test": "customer.phone"
    }
  }, [_vm._v(_vm._s(_vm.date.parseDate(_vm.customer.created_at)))])]) : _vm._e(), _vm._v(" "), (_vm.customer.kind === 'C') ? _c('label', {
    staticClass: "ls-label col-xlg-3 col-lg-4 col-xs-6"
  }, [_c('b', {
    staticClass: "ls-label-text"
  }, [_vm._v(_vm._s(_vm.$t('customers.show.company_name')))]), _vm._v(" "), _c('p', {
    attrs: {
      "data-test": "customer.company_name"
    }
  }, [_vm._v(_vm._s(_vm.customer.company_name))])]) : _vm._e(), _vm._v(" "), (_vm.customer.contact) ? _c('label', {
    staticClass: "ls-label col-lg-4 col-xlg-3 col-xs-6"
  }, [_c('b', {
    staticClass: "ls-label-text"
  }, [_vm._v(_vm._s(_vm.$t('customers.show.phone')))]), _vm._v(" "), _c('p', {
    attrs: {
      "data-test": "customer.phone"
    }
  }, [_vm._v(_vm._s(_vm.getPhone))])]) : _vm._e(), _vm._v(" "), (_vm.customer.kind === 'C') ? _c('label', {
    staticClass: "ls-label col-xlg-3 col-lg-4 col-md-12"
  }, [_c('b', {
    staticClass: "ls-label-text"
  }, [_vm._v(_vm._s(_vm.$t('customers.show.trade_name')))]), _vm._v(" "), _c('p', {
    attrs: {
      "data-test": "customer.trade_name"
    }
  }, [_vm._v(_vm._s(_vm.customer.trade_name))])]) : _vm._e(), _vm._v(" "), _c('label', {
    staticClass: "ls-label col-xlg-3 col-lg-4 col-md-12"
  }, [_c('b', {
    staticClass: "ls-label-text"
  }, [_vm._v(_vm._s(_vm.$t('customers.show.mail')))]), _vm._v(" "), _c('p', {
    attrs: {
      "data-test": "customer.email"
    }
  }, [_vm._v(_vm._s(_vm.customer.email))])]), _vm._v(" "), (_vm.getCode) ? _c('label', {
    staticClass: "ls-label col-xlg-3 col-lg-4 col-md-12"
  }, [_c('b', {
    staticClass: "ls-label-text"
  }, [_vm._v(_vm._s(_vm.$t('customers.show.customer_code')))]), _vm._v(" "), _c('p', {
    attrs: {
      "data-test": "customer.customer_code"
    }
  }, [_vm._v(_vm._s(_vm.getCode))])]) : _vm._e()]), _vm._v(" "), (_vm.customer.address) ? _c('header', [_c('h3', {
    staticClass: "ls-title-3"
  }, [_vm._v(_vm._s(_vm.$t('customers.show.address')))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "ls-box-body row ls-display-flex flex-wrap-wrap"
  }, [_c('label', {
    staticClass: "ls-label col-xlg-3 col-lg-4 col-xs-12"
  }, [_c('b', {
    staticClass: "ls-label-text"
  }, [_vm._v(_vm._s(_vm.$t('customers.attributes.address.street')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.customer.address.street))])]), _vm._v(" "), _c('label', {
    staticClass: "ls-label col-xlg-3 col-lg-4 col-xs-6"
  }, [_c('b', {
    staticClass: "ls-label-text"
  }, [_vm._v(_vm._s(_vm.$t('customers.attributes.address.number')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.customer.address.number))])]), _vm._v(" "), _c('label', {
    staticClass: "ls-label col-xlg-3 col-lg-4  col-xs-6"
  }, [_c('b', {
    staticClass: "ls-label-text"
  }, [_vm._v(_vm._s(_vm.$t('customers.attributes.address.neighborhood')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.customer.address.neighborhood))])]), _vm._v(" "), (_vm.customer.address.complement) ? _c('label', {
    staticClass: "ls-label col-xlg-3 col-lg-2 col-xs-6"
  }, [_c('b', {
    staticClass: "ls-label-text"
  }, [_vm._v(_vm._s(_vm.$t('customers.attributes.address.complement')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.customer.address.complement))])]) : _vm._e(), _vm._v(" "), _c('label', {
    staticClass: "ls-label col-xlg-3 col-lg-4 col-xs-6"
  }, [_c('b', {
    staticClass: "ls-label-text"
  }, [_vm._v(_vm._s(_vm.$t('customers.attributes.address.postal_code')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.customer.address.postal_code))])]), _vm._v(" "), _c('label', {
    staticClass: "ls-label col-xlg-3 col-lg-4 col-xs-6"
  }, [_c('b', {
    staticClass: "ls-label-text"
  }, [_vm._v(_vm._s(_vm.$t('customers.attributes.address.city')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.customer.address.city))])]), _vm._v(" "), _c('label', {
    staticClass: "ls-label col-xlg-3 col-lg-4 col-xs-6"
  }, [_c('b', {
    staticClass: "ls-label-text"
  }, [_vm._v(_vm._s(_vm.$t('customers.attributes.address.state')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.customer.address.state))])])]), _vm._v(" "), _c('br')])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-xlg-6 col-lg-5 ls-no-padding ls-display-flex flex-wrap-wrap"
  }, [_c('div', {
    staticClass: "col-md-12 col-lg-12 col-xlg-12 ls-md-margin-bottom"
  }, [_c('div', {
    staticClass: "ls-box ls-sm-space align-itens-strech"
  }, [_c('header', [_c('h3', {
    staticClass: "ls-title-3"
  }, [_vm._v(_vm._s(_vm.$t('customers.show.last_invoices')))])]), _vm._v(" "), (_vm.invoices.length) ? _c('table', {
    staticClass: "ls-table ls-txt-center ls-sm-space ls-table-striped"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "th-subs"
  }, [_vm._v(_vm._s(_vm.$t('customers.show.subscription')))]), _vm._v(" "), _c('th', {
    staticClass: "th-value"
  }, [_vm._v(_vm._s(_vm.$t('customers.show.value')))]), _vm._v(" "), _c('th', {
    staticClass: "th-status"
  }, [_vm._v(_vm._s(_vm.$t('customers.show.status')))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.invoices), function(invoice) {
    return _c('tr', [(invoice.contract) ? _c('td', {
      staticClass: "th-subs"
    }, [_c('router-link', {
      staticClass: "link",
      attrs: {
        "to": {
          name: 'contract_details',
          params: {
            id: invoice.contract.id
          }
        },
        "title": ""
      }
    }, [_vm._v(_vm._s(invoice.contract.id))])], 1) : _vm._e(), _vm._v(" "), _c('td', {
      staticClass: "th-value"
    }, [_vm._v("R$ " + _vm._s(_vm.money.parseViewValue(invoice.amount_due)))]), _vm._v(" "), _c('td', {
      staticClass: "th-status"
    }, [_vm._v(_vm._s(_vm.$t('invoices.attributes.statuses.' + invoice.status)))])])
  }))]) : _c('p', [_vm._v(_vm._s(_vm.$t('invoices.alerts.not_available')))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12 ls-md-margin-bottom"
  }, [_c('div', {
    staticClass: "ls-box ls-sm-space align-itens-strech"
  }, [_c('header', {
    staticClass: "d-flex"
  }, [_c('div', {
    staticClass: "col-md-8 col-lg-7 align-self-center"
  }, [_c('h3', {
    staticClass: "ls-title-3"
  }, [_vm._v(_vm._s(_vm.$t('customers.show.subscriptions_history')))])]), _vm._v(" "), _c('div', {
    staticClass: "col-xlg-5 col-lg-6"
  }, [(_vm.customer.active) ? _c('router-link', {
    staticClass: "ls-btn ls-no-margin ls-float-right",
    attrs: {
      "to": {
        name: 'contracts_new',
        params: {
          customer: _vm.customer
        }
      }
    },
    slot: "button"
  }, [_c('i', {
    staticClass: "fa fa-calendar-plus-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('customers.main.create_contract')))])]) : _vm._e()], 1)]), _vm._v(" "), (_vm.contracts.length) ? _c('table', {
    staticClass: "ls-table ls-txt-center ls-sm-space ls-table-striped"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "th-id"
  }, [_vm._v(_vm._s(_vm.$t('customers.show.subscription')))]), _vm._v(" "), _c('th', {
    staticClass: "th-date hidden-xs"
  }, [_vm._v(_vm._s(_vm.$t('customers.show.subscription_init')))]), _vm._v(" "), _c('th', {
    staticClass: "hidden-sm hidden-md hidden-xs hidden-lg"
  }, [_vm._v(_vm._s(_vm.$t('customers.show.subscription_end')))]), _vm._v(" "), _c('th', {
    staticClass: "th-status"
  }, [_vm._v(_vm._s(_vm.$t('customers.show.status')))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.contracts), function(contract) {
    return _c('tr', [_c('td', {
      staticClass: "th-id"
    }, [_c('router-link', {
      staticClass: "link",
      attrs: {
        "to": {
          name: 'contract_details',
          params: {
            id: contract.id
          }
        },
        "title": ""
      }
    }, [_vm._v(_vm._s(contract.id))])], 1), _vm._v(" "), _c('td', {
      staticClass: "th-date hidden-xs"
    }, [_vm._v(_vm._s(_vm.beginDate(contract)))]), _vm._v(" "), _c('td', {
      staticClass: "th-date hidden-sm hidden-md hidden-xs  hidden-lg"
    }, [_vm._v(_vm._s(_vm.endDate(contract)))]), _vm._v(" "), _c('td', {
      staticClass: "th-status"
    }, [_vm._v(_vm._s(_vm.$t('contracts.attributes.statuses.' + contract.status)))])])
  }))]) : _c('p', {
    staticClass: "ls-md-margin-top"
  }, [_vm._v(_vm._s(_vm.$t('contracts.alerts.subscription_not_found')))])])])])]), _vm._v(" "), _c('modal-inactive', {
    model: {
      value: (_vm.inactiveObjects),
      callback: function($$v) {
        _vm.inactiveObjects = $$v
      },
      expression: "inactiveObjects"
    }
  })], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-072f40e9"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/pages/customers/Show.vue
// module id = 722
// module chunks = 1